module.exports = __webpack_public_path__ + "static/media/reward-card-center.3a34ed7d.svg";